import React from 'react'
import { useMarketoForms } from 'marketing-site/src/components/context/MarketoFormsContext'

import { IProps } from './index'
import { IMarketoField } from 'marketing-site/lib/marketo/@types/fields'
import { MultiStepForm } from '../MultiStepForm'
import { variationAExcludedFields, variationBExcludedFields } from './formVariations'

export const ViewDemosMultiStepForm: React.FC<IProps> = ({
  variation = 'A',
  marketoProps,
  submitButtonLabels,
}) => {
  const marketoForms = useMarketoForms()
  const { formId } = marketoProps
  const formData = marketoForms.find((f) => f.id === formId)

  const excludedFields = variation === 'B' ? variationBExcludedFields : variationAExcludedFields

  let formFirstStepFields: IMarketoField[] = []
  let formSecondStepFields: IMarketoField[] = []
  if (formData) {
    const firstStepFields = formData.fields.filter(
      (field) => !excludedFields.step1.includes(field.id),
    )
    const secondStepFields = formData.fields.filter(
      (field) => !excludedFields.step2.includes(field.id),
    )
    formFirstStepFields = firstStepFields
    formSecondStepFields = secondStepFields
  }

  const multiStepFormProps = {
    marketoProps,
    formFields: {
      step1: formFirstStepFields,
      step2: formSecondStepFields,
    },
    submitButtonLabels,
  }
  return (
    <div className="view-demos-multi-step-form" data-testid="view-demos-multi-step-form">
      <MultiStepForm {...multiStepFormProps} />
    </div>
  )
}
